import type { ReactNode } from "react";
import { MiniSidebarHeader } from "@/components/course/tree/MiniSidebarHeader";
import { cn } from "@/lib/utils";

interface CourseTreeShellProps {
  showMinimizedSidebar?: boolean;
  onExpandSidebar?: () => void;
  children: ReactNode;
  className?: string;
}

/**
 * Course tree sidebar chrome — used to wrap the module list and fade between
 * the full and minimized table of contents.
 */
const CourseTreeShell = ({
  showMinimizedSidebar,
  onExpandSidebar,
  children,
  className,
}: CourseTreeShellProps) => (
  <div className={cn("flex flex-col h-full bg-white", className)}>
    {/* key forces remount so the fade-in runs on mini/full switch */}
    <div
      key={showMinimizedSidebar ? "mini" : "full"}
      className="flex flex-col h-full animate-in fade-in duration-200"
    >
      {showMinimizedSidebar && <MiniSidebarHeader onExpand={onExpandSidebar} />}
      <div className="flex-1 overflow-y-auto py-3">{children}</div>
    </div>
  </div>
);

export default CourseTreeShell;
